<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
</ngx-spinner>

<div class="brpt">
  <section class="brpt__card brpt__card--filter">
    <header class="brpt__head">
      <div class="brpt__head-left">
        <img
          class="brpt__head-icon"
          [src]="icons.filterBudget"
          alt=""
          width="36"
          height="36"
          aria-hidden="true"
        />
        <div>
          <h1 class="brpt__title">Filter Budget</h1>
          <p class="brpt__subtitle">Select criteria to view budget details based on selected filters.</p>
        </div>
      </div>
      <button
        type="button"
        class="brpt__create-btn"
        *ngIf="isBudgetFormEnabled"
        (click)="createBudget()"
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M12 5V19" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
          <path d="M5 12H19" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
        </svg>
        Create New Budget
      </button>
    </header>

    <div class="brpt__filters" [class.brpt__filters--expanded]="showMoreFilters">
      <div class="brpt__fld">
        <div class="brpt__fld-row">
          <img class="brpt__fld-icon" [src]="icons.city" alt="" width="32" height="32" aria-hidden="true" />
          <div class="brpt__fld-body">
            <label class="brpt__lbl">City</label>
            <div class="brpt__control brpt__control--select">
              <mat-select
                class="brpt__mat-select"
                placeholder="Select city"
                panelClass="brpt-select-panel"
                disableOptionCentering
                [ngModel]="selectedCity"
                [compareWith]="compareByCity"
                (ngModelChange)="onCityChange($event)"
                (openedChange)="onLocationSelectOpened($event, 'city')"
                [disabled]="isLocationFieldLoading('city') || isApiLoading"
              >
                <input matInput class="brpt__mat-select-input" placeholder="Search city" [formControl]="citySearch" />
                <mat-option *ngFor="let item of cityOptions | async; trackBy: trackByIndex" [value]="item">
                  {{ item['name'] ?? item['cityName'] }}
                </mat-option>
              </mat-select>
            </div>
          </div>
        </div>
      </div>

      <div class="brpt__fld">
        <div class="brpt__fld-row">
          <img class="brpt__fld-icon" [src]="icons.zone" alt="" width="32" height="32" aria-hidden="true" />
          <div class="brpt__fld-body">
            <label class="brpt__lbl">Zone</label>
            <div class="brpt__control brpt__control--select">
              <mat-select
                class="brpt__mat-select"
                placeholder="Select zone"
                panelClass="brpt-select-panel"
                disableOptionCentering
                [ngModel]="selectedZone"
                [compareWith]="compareByZone"
                (ngModelChange)="onZoneChange($event)"
                (openedChange)="onLocationSelectOpened($event, 'zone')"
                [disabled]="isLocationFieldLoading('zone') || isApiLoading"
              >
                <input matInput class="brpt__mat-select-input" placeholder="Search zone" [formControl]="zoneSearch" />
                <mat-option *ngFor="let item of zoneOptions | async; trackBy: trackByIndex" [value]="item">
                  {{ item['zoneName'] ?? item['name'] ?? item['zone'] }}
                </mat-option>
              </mat-select>
            </div>
          </div>
        </div>
      </div>

      <div class="brpt__fld">
        <div class="brpt__fld-row">
          <img class="brpt__fld-icon" [src]="icons.subZone" alt="" width="32" height="32" aria-hidden="true" />
          <div class="brpt__fld-body">
            <label class="brpt__lbl">Sub Zone</label>
            <div class="brpt__control brpt__control--select">
              <mat-select
                class="brpt__mat-select"
                placeholder="Select sub zone"
                panelClass="brpt-select-panel"
                disableOptionCentering
                [ngModel]="selectedSubZone"
                [compareWith]="compareBySubZone"
                (ngModelChange)="onSubZoneChange($event)"
                (openedChange)="onLocationSelectOpened($event, 'subZone')"
                [disabled]="isLocationFieldLoading('subZone') || isApiLoading"
              >
                <input matInput class="brpt__mat-select-input" placeholder="Search sub zone" [formControl]="subZoneSearch" />
                <mat-option *ngFor="let item of subZoneOptions | async; trackBy: trackByIndex" [value]="item">
                  {{ item['subZone'] ?? item['name'] ?? item['subZoneName'] }}
                </mat-option>
              </mat-select>
            </div>
          </div>
        </div>
      </div>

      <div class="brpt__fld">
        <div class="brpt__fld-row">
          <img class="brpt__fld-icon" [src]="icons.campus" alt="" width="32" height="32" aria-hidden="true" />
          <div class="brpt__fld-body">
            <label class="brpt__lbl">Campus <span class="brpt__req" aria-hidden="true">*</span></label>
            <div class="brpt__control brpt__control--select">
              <mat-select
                class="brpt__mat-select"
                placeholder="Select campus"
                panelClass="brpt-select-panel"
                disableOptionCentering
                [ngModel]="selectedCampus"
                [compareWith]="compareByCampus"
                (ngModelChange)="onCampusChange($event)"
                (openedChange)="onLocationSelectOpened($event, 'campus')"
                [disabled]="isLocationFieldLoading('campus') || isApiLoading"
              >
                <input matInput class="brpt__mat-select-input" placeholder="Search campus" [formControl]="campusSearch" />
                <mat-option *ngFor="let item of campusOptions | async; trackBy: trackByIndex" [value]="item">
                  {{ item['campusName'] ?? item['name'] ?? item['campus'] }}
                </mat-option>
              </mat-select>
            </div>
          </div>
        </div>
      </div>

      <ng-container *ngIf="showMoreFilters">
        <div class="brpt__fld">
          <div class="brpt__fld-row">
            <img class="brpt__fld-icon" [src]="icons.deanName" alt="" width="32" height="32" aria-hidden="true" />
            <div class="brpt__fld-body">
              <label class="brpt__lbl">Dean Name</label>
              <div class="brpt__control brpt__control--select">
                <mat-select
                  class="brpt__mat-select"
                  placeholder="Select dean"
                  panelClass="brpt-select-panel"
                  disableOptionCentering
                  [ngModel]="selectedDean"
                  [compareWith]="compareByDean"
                  (ngModelChange)="onDeanChange($event)"
                  (openedChange)="onLocationSelectOpened($event, 'deanName')"
                  [disabled]="isLocationFieldLoading('deanName') || isApiLoading"
                >
                  <input matInput class="brpt__mat-select-input" placeholder="Search dean" [formControl]="deanSearch" />
                  <mat-option *ngFor="let item of deanOptions | async; trackBy: trackByIndex" [value]="item">
                    {{ item['deanName'] ?? item['principalDeanName'] ?? item['name'] ?? item['dean'] }}
                  </mat-option>
                </mat-select>
              </div>
            </div>
          </div>
        </div>

        <div class="brpt__fld">
          <div class="brpt__fld-row">
            <img class="brpt__fld-icon" [src]="icons.employeeType" alt="" width="32" height="32" aria-hidden="true" />
            <div class="brpt__fld-body">
              <label class="brpt__lbl">Employee Type</label>
              <div class="brpt__control brpt__control--select">
                <mat-select
                  class="brpt__mat-select"
                  placeholder="Select employee type"
                  panelClass="brpt-select-panel"
                  disableOptionCentering
                  [(ngModel)]="selectedEmpType"
                  [compareWith]="compareById"
                  [disabled]="expandedFiltersLoading || isApiLoading"
                >
                  <input matInput class="brpt__mat-select-input" placeholder="Search employee type" [formControl]="empTypeSearch" />
                  <mat-option *ngFor="let item of empTypeOptions | async; trackBy: trackByIndex" [value]="item">
                    {{ item['label'] ?? item['empType'] ?? item['employeeType'] ?? item['name'] }}
                  </mat-option>
                </mat-select>
              </div>
            </div>
          </div>
        </div>

        <div class="brpt__fld">
          <div class="brpt__fld-row">
            <img class="brpt__fld-icon" [src]="icons.teachingType" alt="" width="32" height="32" aria-hidden="true" />
            <div class="brpt__fld-body">
              <label class="brpt__lbl">Teaching Type</label>
              <div class="brpt__control brpt__control--select">
                <mat-select
                  class="brpt__mat-select"
                  placeholder="Select teaching type"
                  panelClass="brpt-select-panel"
                  disableOptionCentering
                  [ngModel]="selectedTeachingType"
                  [compareWith]="compareById"
                  (ngModelChange)="onTeachingTypeChange($event)"
                  [disabled]="expandedFiltersLoading || teachingTypeLoading || isApiLoading"
                >
                  <input matInput class="brpt__mat-select-input" placeholder="Search teaching type" [formControl]="teachingTypeSearch" />
                  <mat-option *ngFor="let item of teachingTypeOptions | async; trackBy: trackByIndex" [value]="item">
                    {{ item['roleType'] ?? item['TeachType'] ?? item['name'] }}
                  </mat-option>
                </mat-select>
              </div>
            </div>
          </div>
        </div>

        <div class="brpt__fld">
          <div class="brpt__fld-row">
            <img class="brpt__fld-icon" [src]="icons.department" alt="" width="32" height="32" aria-hidden="true" />
            <div class="brpt__fld-body">
              <label class="brpt__lbl">Department</label>
              <div class="brpt__control brpt__control--select">
                <mat-select
                  class="brpt__mat-select"
                  placeholder="Select department"
                  panelClass="brpt-select-panel"
                  disableOptionCentering
                  [ngModel]="selectedDepartment"
                  [compareWith]="compareById"
                  (ngModelChange)="onDepartmentChange($event)"
                  [disabled]="teachingTypeLoading || !selectedTeachingType || isApiLoading"
                >
                  <input matInput class="brpt__mat-select-input" placeholder="Search department" [formControl]="departmentSearch" />
                  <mat-option *ngFor="let item of departmentOptions | async; trackBy: trackByIndex" [value]="item">
                    {{ item['deptName'] ?? item['departmentName'] ?? item['name'] }}
                  </mat-option>
                </mat-select>
              </div>
            </div>
          </div>
        </div>

        <div class="brpt__fld">
          <div class="brpt__fld-row">
            <img class="brpt__fld-icon" [src]="icons.designation" alt="" width="32" height="32" aria-hidden="true" />
            <div class="brpt__fld-body">
              <label class="brpt__lbl">Designation</label>
              <div class="brpt__control brpt__control--select">
                <mat-select
                  class="brpt__mat-select"
                  placeholder="Select designation"
                  panelClass="brpt-select-panel"
                  disableOptionCentering
                  [(ngModel)]="selectedDesignation"
                  [compareWith]="compareById"
                  [disabled]="teachingTypeLoading || !selectedDepartment || isApiLoading"
                >
                  <input matInput class="brpt__mat-select-input" placeholder="Search designation" [formControl]="designationSearch" />
                  <mat-option *ngFor="let item of designationOptions | async; trackBy: trackByIndex" [value]="item">
                    {{ item['desigName'] ?? item['designation'] ?? item['name'] }}
                  </mat-option>
                </mat-select>
              </div>
            </div>
          </div>
        </div>

        <div class="brpt__fld">
          <div class="brpt__fld-row">
            <img class="brpt__fld-icon" [src]="icons.budget" alt="" width="32" height="32" aria-hidden="true" />
            <div class="brpt__fld-body">
              <label class="brpt__lbl">Budget</label>
              <div class="brpt__control brpt__control--select">
                <mat-select
                  class="brpt__mat-select"
                  placeholder="Select budget"
                  panelClass="brpt-select-panel"
                  disableOptionCentering
                  [(ngModel)]="selectedBudget"
                  [compareWith]="compareById"
                  [disabled]="expandedFiltersLoading || isApiLoading"
                >
                  <input matInput class="brpt__mat-select-input" placeholder="Search budget year" [formControl]="budgetSearch" />
                  <mat-option *ngFor="let item of budgetOptions | async; trackBy: trackByIndex" [value]="item">
                    {{ item['label'] ?? item['value'] }}
                  </mat-option>
                </mat-select>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <div class="brpt__fld brpt__fld--action">
        <div class="brpt__filter-actions">
          <button
            type="button"
            class="brpt__apply-btn"
            [disabled]="loading || isApiLoading || !selectedCampus"
            (click)="applyFilter()"
          >
            {{ loading ? 'Loading...' : 'Apply Filter' }}
          </button>
          <button
            type="button"
            class="brpt__clear-btn"
            [disabled]="loading || isApiLoading"
            (click)="clearFilters()"
          >
            Clear
          </button>
        </div>
      </div>
    </div>

    <div class="brpt__more-wrap">
      <button type="button" class="brpt__more-link" [disabled]="isApiLoading" (click)="toggleViewMoreFilters()">
        {{ showMoreFilters ? 'Close' : 'View More option' }}
        <svg
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          aria-hidden="true"
          [class.brpt__chevron--up]="showMoreFilters"
        >
          <path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
        </svg>
      </button>
    </div>
  </section>

  <section class="brpt__card brpt__card--list" *ngIf="listLoaded">
    <header class="brpt__list-head">
      <div class="brpt__list-title-wrap">
        <img
          class="brpt__head-icon brpt__head-icon--list"
          [src]="icons.budgetList"
          alt=""
          width="40"
          height="40"
          aria-hidden="true"
        />
        <div>
          <h2 class="brpt__list-title">Budget List</h2>
          <p class="brpt__list-count">{{ recordCountLabel }}</p>
        </div>
      </div>

      <div class="brpt__total-card">
        <img
          class="brpt__total-icon"
          [src]="icons.totalBudgetWallet"
          alt=""
          width="20"
          height="20"
          aria-hidden="true"
        />
        <div class="brpt__total-copy">
          <span class="brpt__total-label">Total Budget</span>
          <span class="brpt__total-value">{{ totalBudgetLabel }}</span>
        </div>
      </div>

      <div class="brpt__toolbar brpt__toolbar--head">
        <div class="brpt__search-wrap">
          <input
            type="text"
            class="brpt__search-input"
            placeholder="Search"
            [value]="quickFilter"
            (input)="onQuickFilterChanged($event)"
          />
          <span class="brpt__search-icon" aria-hidden="true">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <circle cx="11" cy="11" r="6.5" stroke="currentColor" stroke-width="1.8" />
              <path d="M16 16L20.5 20.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
            </svg>
          </span>
        </div>
        <button type="button" class="brpt__export-btn" [disabled]="!displayRowData.length" (click)="exportReport()">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M12 4V15" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
            <path d="M8 11L12 15L16 11" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
            <path d="M5 20H19" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
          </svg>
          Export
        </button>
      </div>
    </header>

    <div class="brpt__grid-wrap">
      <ag-grid-angular
        class="ag-theme-alpine brpt__grid"
        [rowData]="displayRowData"
        [columnDefs]="columnDefs"
        [defaultColDef]="defaultColDef"
        [overlayNoRowsTemplate]="overlayNoRowsTemplate"
        [quickFilterText]="quickFilter"
        [animateRows]="true"
        [suppressCellFocus]="true"
        [rowHeight]="38"
        [headerHeight]="40"
        (gridReady)="onGridReady($event)"
      >
      </ag-grid-angular>
    </div>
  </section>
</div>
